export default "__VITE_ASSET__hg_CBXgb__"